import styles from "./style.module.css";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  CodarxActionRow,
  CodarxBtn,
  CodarxCard,
  CodarxCheckBox,
  CodarxDatePicker,
  CodarxDropDown,
  CodarxInput,
  CodarxTextArea,
  CodarxTimePicker,
  MapComponent,
  MapMarker,
  Title,
} from "components";
import Skeleton from "react-loading-skeleton";
import {
  Col,
  Row,
  Form,
  notification,
  Popconfirm,
  Tag,
  message,
  Button,
  Select,
  Checkbox,
} from "antd";
import {
  DeleteVendor,
  DeleteVendorHolidayById,
  GetSingleVendor,
  GetVendorByIdUpdateArea,
  GetVendorCoveragesArea,
  GetVendorHolidays,
  GetVendorRegions,
  PostVendorHolidays,
  UpdateVendor,
} from "services/vendors";
import {
  DeleteDeliveryRange,
  GetSingleDeliveryRange,
  PostDeliveryRange,
} from "services/delivery";

import { useFormik } from "formik";
import * as Yup from "yup";
import CodarxImageModal from "components/CodarxImageModal";
import { useMediaQuery } from "utils/useMediaQuery";
import { DeliveryRangeModal } from "./components/DeliveryRangeModal";
import { DangerVector } from "assets/images";
import { useMutation, useQuery, useQueryClient } from "react-query";
import moment from "moment";
import fa_IR from "antd/es/locale/fa_IR";
import { getUsers } from "services/user";
import { useSearchDebounce } from "utils/useDebouncedSearch";
import { _parseInputPrice, IsUserPermitted } from "utils/_helpers";
import { GetCustomerSegment } from "services/customer";
import L from "leaflet";
import {
  MapContainer,
  Marker,
  Polygon,
  Popup,
  TileLayer,
  useMapEvents,
} from "react-leaflet";
import "leaflet.vectorgrid";

const deleteIcon = L.divIcon({
  html: `<div style="background:red; color:white; border-radius:50%; width:20px; height:20px; display:flex; align-items:center; justify-content:center; font-size:10px; cursor:pointer;">X</div>`,
  className: "",
  iconSize: [20, 20],
  iconAnchor: [0, 24],
});

export const getCentroid = (points) => {
  if (!points.length) return null;

  const latSum = points.reduce((sum, p) => sum + p[1], 0);
  const lngSum = points.reduce((sum, p) => sum + p[0], 0);

  const latAvg = latSum / points.length;
  const lngAvg = lngSum / points.length;

  return [latAvg, lngAvg];
};

function distancePointToSegment(p, a, b) {
  const px = p.lng,
    py = p.lat;
  const ax = a.lng,
    ay = a.lat;
  const bx = b.lng,
    by = b.lat;

  const dx = bx - ax;
  const dy = by - ay;

  if (dx === 0 && dy === 0) {
    return Math.hypot(px - ax, py - ay);
  }

  let t = ((px - ax) * dx + (py - ay) * dy) / (dx * dx + dy * dy);
  t = Math.max(0, Math.min(1, t));

  const cx = ax + t * dx;
  const cy = ay + t * dy;

  return Math.hypot(px - cx, py - cy);
}

function insertPoint(polygon, newPoint) {
  if (polygon.length < 2) return [...polygon, newPoint];

  let insertIndex = 0;
  let minDist = Infinity;

  for (let i = 0; i < polygon.length; i++) {
    const j = (i + 1) % polygon.length;
    const dist = distancePointToSegment(newPoint, polygon[i], polygon[j]);
    if (dist < minDist) {
      minDist = dist;
      insertIndex = j;
    }
  }

  const updated = [...polygon];
  updated.splice(insertIndex, 0, newPoint);
  return updated;
}

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "نام باید حداقل 3 کاراکتر باشد")
    .required("وارد کردن این فیلد الزامی است"),
  address: Yup.string().nullable(),
  state: Yup.string().nullable(),
  city: Yup.string().nullable(),
  start_work_hour: Yup.mixed().required(),
  end_work_hour: Yup.mixed().required(),
  featured_image: Yup.mixed(),
  shipping_cost: Yup.number().nullable(),
  minimum_purchase: Yup.number().nullable(),
  shipping_time: Yup.number().nullable(),
  time_to_delivery: Yup.number().nullable(),
  is_active: Yup.bool(),
  requires_delivery_code: Yup.bool(),
  free_delivery: Yup.number().nullable(),
  coordinates: Yup.array().length(2).nullable().notRequired(),
});

const initialValues = {
  id: undefined,
  name: undefined,
  is_active: false,
  free_delivery: false,
  rider: [],
};

const weekDays = [
  { id: "saturday", label: "شنبه" },
  { id: "sunday", label: "یکشنبه" },
  { id: "monday", label: "دوشنبه" },
  { id: "tuesday", label: "سه شنبه" },
  { id: "wednesday", label: "چهارشنبه" },
  { id: "thursday", label: "پنج شنبه" },
  { id: "friday", label: "جمعه" },
];

const CustomDorpDown = (props) => (
  <CodarxDropDown
    {...props}
    textColor={props.colorPalette.text.main}
    borderColor={props.colorPalette.text.op_7}
    activeBgColor={props.colorPalette.primary.op_8}
    activeColor={props.colorPalette.primary.op_1}
    borderHoverColor={props.colorPalette.primary.op_10}
  />
);
export default function SingleVendor() {
  const colorPalette = useSelector(({ theme }) => theme.palette);
  const isTabletOrMobile = useMediaQuery("(max-width:992px)");
  const queryClient = useQueryClient();

  const { id } = useParams();
  const navigate = useNavigate();

  const [markerArray, setMarkerArray] = useState([]);
  const [imageModalIsOpen, setImageModalIsOpen] = useState(false);
  const [deliveryRanges, setDeliveryRanges] = useState([]);
  const [deliveyRangeModal, setDeliveryRangeModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [regions, setRegions] = useState([]);
  const [holidayDate, setHolidayDate] = useState("");
  const [userSearchDebounce, setUserSearchDebounce] = useSearchDebounce(500);
  const [segments, setSegments] = useState([]);
  const [polygon, setPolygon] = useState([]);
  const [coverages, setCoverages] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [LocMarker, setLocaMarker] = useState([]);
  const [isEditingMap, setIsEditingMap] = useState(false);

  const hoverTimeout = useRef(null);
  const mapRef = useRef(undefined);
  const mapLocRef = useRef(undefined);
  const isMarkerDragging = useRef(false);

  const { data: users } = useQuery(
    ["user-search", userSearchDebounce],
    () => getUsers([], { search: userSearchDebounce }),
    {
      refetchOnWindowFocus: false,
    },
  );

  const onFinish = (values) => {
    setLoading(true);
    const { rider, ...valsToSend } = values;
    const formData = {
      ...valsToSend,
      name: valsToSend.name,
      region: valsToSend?.region?.value,
      featured_image: valsToSend?.featured_image?.id,
      support_area: valsToSend.new_support_area,
      latitude: LocMarker.length > 0 && LocMarker[0],
      longitude: LocMarker.length > 0 && LocMarker[1],
    };

    if (polygon && polygon.length > 0) {
      formData["geometry"] = {
        type: "Polygon",
        coordinates: [
          [
            ...polygon.map((pl) => [pl.lng, pl.lat]),
            [polygon[0].lng, polygon[0].lat],
          ],
        ],
      };
    }

    rider.map((_rd) => formData.append("rider", _rd.id));

    UpdateVendor(id, formData)
      .then((res) => {
        setLoading(false);
        notification.success({
          message: "درخواست شما با موفقیت انجام شد.",
        });
        formik.setValues({
          ...res,
          coordinates: res?.latitude &&
            res?.longitude && [res.longitude, res.latitude],
        });
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => onFinish(values),
    validationSchema,
    validateOnChange: false,
    enableReinitialize: true,
  });

  const mapOnClick = (_, e) => {
    const array = [];
    array.push(
      <MapMarker coordinates={[e.lngLat.lng, e.lngLat.lat]} anchor="bottom" />,
    );
    setMarkerArray(array);
    formik.setFieldValue("coordinates", [e.lngLat.lng, e.lngLat.lat]);
  };

  const createDeliveryRange = (values) => {
    setLoading(true);
    PostDeliveryRange({ body: { ...values, vendor: id } })
      .then((result) => {
        setLoading(false);
        setDeliveryRangeModal(false);
        message.success("بازه با موفقیت ایجاد شد");
        _getDeliveryRanges();
      })
      .catch((err) => {
        message.error("خطا در ایجاد بازه");
        setLoading(false);
      });
  };

  const _deleteDeliveryRange = (id) => {
    message.loading("لطفا چندلحظه صبر کنید");
    setLoading(true);
    DeleteDeliveryRange({ id })
      .then((result) => {
        setLoading(false);
        setDeliveryRangeModal(false);
        message.success("بازه با موفقیت حذف شد");
        _getDeliveryRanges();
      })
      .catch((err) => {
        message.error("خطا در حذف بازه");
        setLoading(false);
      });
  };

  const _getDeliveryRanges = () => {
    GetSingleDeliveryRange({ vendor: id, page_size: 1000 })
      .then((result) => {
        setDeliveryRanges(result.results);
      })
      .catch((err) => {});
  };

  const _getCoverages = () => {
    GetVendorCoveragesArea()
      .then((result) => {
        let data = [];
        result
          ?.filter((res) => res.id != id)
          .map((pol) => {
            const center = getCentroid(pol?.geometry?.coordinates[0]);
            data.push({
              name: pol?.name,
              center,
              coordinates: pol?.geometry?.coordinates[0].map((cd) => ({
                lat: cd[0],
                lng: cd[1],
              })),
            });
          });
        setCoverages([...data]);
      })
      .catch((err) => {});
  };

  const _getRegions = (search = "") => {
    GetVendorRegions({ search })
      .then((result) => {
        setRegions([
          { label: "بدون منطقه", value: null },
          ...result.results.map((item) => ({
            label: item.name,
            value: item.id,
          })),
        ]);
      })
      .catch((err) => {});
  };

  const _getSegments = () => {
    GetCustomerSegment({
      page_size: 100,
    })
      .then((result) => {
        setSegments(result.results);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    GetSingleVendor(id)
      .then((res) => {
        res.latitude &&
          res.longitude &&
          setLocaMarker([res.latitude, res.longitude]);
        formik.setValues({
          ...res,
          region: res.region
            ? { value: res.region.id, label: res.region.name }
            : null,
          coordinates: res?.latitude &&
            res?.longitude && [res.latitude, res.longitude],
        });
        if (res.geometry && res?.geometry?.coordinates.length > 0) {
          setPolygon(
            res?.geometry?.coordinates[0].map((cd) => ({
              lat: cd[1],
              lng: cd[0],
            })),
          );
          const center = getCentroid(res?.geometry?.coordinates[0]);
          if (center)
            mapRef.current.setView(
              {
                lat: center[0],
                lng: center[1],
              },
              13,
            );
        }
      })
      .catch((error) => {});
    _getRegions();
    _getCoverages();
  }, [id]);

  useEffect(() => {
    if (formik.values.coordinates) {
      const array = [];
      array.push(
        <MapMarker
          coordinates={[
            formik.values.coordinates[0],
            formik.values.coordinates[1],
          ]}
          anchor="bottom"
        />,
      );
      setMarkerArray(array);
    }
  }, [formik.values.coordinates]);

  const { data: holidays } = useQuery(
    `vendor-${id}-holidays`,
    () =>
      GetVendorHolidays({
        params: {
          vendor: id,
          page_size: 100,
        },
      }),
    {
      refetchOnWindowFocus: false,
    },
  );

  const createHoliday = useMutation(PostVendorHolidays, {
    onSuccess: () => {
      queryClient.refetchQueries(`vendor-${id}-holidays`);
      setHolidayDate("");
    },
  });

  const deleteHoliday = useMutation(DeleteVendorHolidayById, {
    onSuccess: () => {
      queryClient.refetchQueries(`vendor-${id}-holidays`);
    },
  });

  useEffect(() => {
    _getDeliveryRanges();
    _getSegments();
  }, [id]);

  const LocMapClickHandler = () => {
    useMapEvents({
      click(e) {
        if (!isEditingMap) return;
        setLocaMarker([e.latlng.lat, e.latlng.lng]);
      },
    });
    return null;
  };

  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        if (isMarkerDragging.current) return;

        const newPoint = { lat: e.latlng.lat, lng: e.latlng.lng };
        setPolygon((prev) => insertPoint(prev, newPoint));
      },
    });
    return null;
  };

  const updatePoint = (index, latlng) => {
    setPolygon((prev) => {
      const updated = [...prev];
      updated[index] = { lat: latlng?.lat, lng: latlng?.lng };
      return updated;
    });
  };

  const deletePoint = (index) => {
    setPolygon((prev) => prev.filter((_, i) => i !== index));
    setHoveredIndex(null);
  };

  return (
    <div>
      <Row style={{ marginBottom: 32 }} gutter={16}>
        <DeliveryRangeModal
          visible={deliveyRangeModal}
          onCancel={() => setDeliveryRangeModal(false)}
          onOk={(values) => createDeliveryRange(values)}
          loading={loading}
        />
        {formik.values.id ? (
          <Col span={24}>
            <Title text={formik.values && formik.values.name} />
          </Col>
        ) : (
          <Col xs={{ span: 24 }} lg={{ span: 16 }}>
            <Skeleton height={58} />
          </Col>
        )}
      </Row>
      <Row style={{ marginBottom: 32 }} gutter={16}>
        <Col xs={{ span: 24 }} lg={{ span: 16 }}>
          {formik.values.id ? (
            <CodarxCard style={{ marginBottom: 32 }}>
              <h2 className={"title"}>اطلاعات فروشگاه</h2>
              <div
                className={styles.add_img_container}
                style={{ marginBottom: 24 }}
              >
                {formik.values.featured_image === undefined ? (
                  <div
                    style={{
                      borderColor: colorPalette.primary.main,
                      marginRight:
                        formik.values.featured_image === null ? "0px" : "",
                    }}
                    className={styles.add_img_btn}
                    onClick={() => {
                      setImageModalIsOpen(true);
                    }}
                  >
                    <i
                      style={{ color: colorPalette.primary.main }}
                      className="iconly-Plus"
                    ></i>
                  </div>
                ) : isTabletOrMobile ? (
                  <div style={{ width: "100%" }}>
                    <div className={styles.product_img_layout}>
                      {formik.values.featured_image && (
                        <img
                          src={formik.values.featured_image?.file}
                          alt={formik.values.featured_image.alt}
                          width="80px"
                          height="80px"
                          style={{ objectFit: "contain" }}
                        />
                      )}
                    </div>
                    <div className={styles.category_edit_image_m}>
                      <CodarxBtn
                        onClick={() => {
                          setImageModalIsOpen(true);
                        }}
                        ghost={true}
                        height="40"
                      >
                        <i
                          className="iconly-Edit"
                          style={{ fontSize: "24px", marginLeft: "8px" }}
                        ></i>
                        ویرایش عکس
                      </CodarxBtn>
                    </div>
                  </div>
                ) : (
                  <div className={styles.product_img_container}>
                    <div className={styles.product_img_layout}>
                      {formik.values.featured_image && (
                        <img
                          src={formik.values.featured_image?.file}
                          alt={formik.values.featured_image.alt}
                          width="80px"
                          height="80px"
                          style={{ objectFit: "contain" }}
                        />
                      )}
                    </div>
                    {IsUserPermitted("vendor", "change") && (
                      <CodarxBtn
                        style={{}}
                        onClick={() => {
                          setImageModalIsOpen(true);
                        }}
                        ghost={true}
                        width="160"
                        height="40"
                      >
                        <i
                          className="iconly-Edit"
                          style={{ fontSize: "24px", marginLeft: "8px" }}
                        ></i>
                        ویرایش عکس
                      </CodarxBtn>
                    )}
                  </div>
                )}
              </div>
              <CodarxImageModal
                type={formik.values.featured_image ? "edit" : "create"}
                onFinish={(data) => {
                  formik.setFieldValue("featured_image", data);
                }}
                visible={imageModalIsOpen}
                setVisible={setImageModalIsOpen}
                imageFileData={
                  formik.values.featured_image
                    ? formik.values.featured_image
                    : null
                }
              />
              <Row gutter={16}>
                <Col xs={24} lg={12} style={{ marginBottom: 12 }}>
                  <CodarxInput
                    width={"100%"}
                    message={
                      formik.errors.name && {
                        type: "error",
                        rightComponent: formik.errors.name,
                      }
                    }
                    value={formik.values.name}
                    onChange={(e) =>
                      formik.setFieldValue("name", e.target.value)
                    }
                    placeholder={"نام فروشگاه"}
                  />
                </Col>
                <Col xs={24} lg={12} style={{ marginBottom: 12 }}></Col>
                <Col xs={24} lg={12} style={{ marginBottom: 12 }}>
                  <CodarxTimePicker
                    width={"100%"}
                    message={
                      formik.errors.start_work_hour && {
                        type: "error",
                        rightComponent: formik.errors.start_work_hour,
                      }
                    }
                    value={formik.values.start_work_hour}
                    onChange={(e) => {
                      formik.setFieldValue("start_work_hour", e);
                    }}
                    placeholder={"ساعت شروع کار"}
                  />
                </Col>
                <Col xs={24} lg={12} style={{ marginBottom: 12 }}>
                  <CodarxTimePicker
                    width={"100%"}
                    message={
                      formik.errors.end_work_hour && {
                        type: "error",
                        rightComponent: formik.errors.end_work_hour,
                      }
                    }
                    value={formik.values.end_work_hour}
                    onChange={(e) => {
                      formik.setFieldValue("end_work_hour", e);
                    }}
                    placeholder={"ساعت پایان کار"}
                  />
                </Col>
                <Col xs={24} lg={12} style={{ marginBottom: 12 }}>
                  <CodarxInput
                    width={"100%"}
                    message={
                      formik.errors.state && {
                        type: "error",
                        rightComponent: formik.errors.state,
                      }
                    }
                    value={formik.values.state}
                    onChange={(e) => {
                      formik.setFieldValue("state", e.target.value);
                    }}
                    placeholder={"استان"}
                  />
                </Col>
                <Col xs={24} lg={12} style={{ marginBottom: 12 }}>
                  <CodarxInput
                    width={"100%"}
                    message={
                      formik.errors.city && {
                        type: "error",
                        rightComponent: formik.errors.city,
                      }
                    }
                    value={formik.values.city}
                    onChange={(e) => {
                      formik.setFieldValue("city", e.target.value);
                    }}
                    placeholder={"شهر"}
                  />
                </Col>
                <Col xs={24} style={{ marginBottom: 12 }}>
                  <CodarxTextArea
                    width={"100%"}
                    message={
                      formik.errors.address && {
                        type: "error",
                        rightComponent: formik.errors.address,
                      }
                    }
                    value={formik.values.address}
                    onChange={(e) => {
                      formik.setFieldValue("address", e.target.value);
                    }}
                    placeholder={"آدرس"}
                  />
                  {formik.errors.address && (
                    <div
                      style={{
                        color: colorPalette.text.op_3,
                        fontSize: 10,
                        marginTop: 12,
                      }}
                    >
                      <img
                        style={{ height: 13, marginLeft: 3 }}
                        src={DangerVector}
                      />
                      {formik.errors.address}
                    </div>
                  )}
                </Col>
              </Row>
              <CodarxCheckBox
                onChange={(e) =>
                  formik.setFieldValue("is_active", e.target.checked)
                }
                checked={formik.values.is_active}
              >
                <span style={{ fontSize: 12, color: colorPalette.text.op_3 }}>
                  فروشگاه فعال است.
                </span>
              </CodarxCheckBox>
              <CodarxCheckBox
                onChange={(e) =>
                  formik.setFieldValue(
                    "requires_delivery_code",
                    e.target.checked,
                  )
                }
                checked={formik.values.requires_delivery_code}
              >
                <span style={{ fontSize: 12, color: colorPalette.text.op_3 }}>
                  برای تحویل سفارش نیاز به کد اسنپ دارد
                </span>
              </CodarxCheckBox>
            </CodarxCard>
          ) : (
            <Skeleton height={250} style={{ marginBottom: 32 }} />
          )}
          {formik.values.id ? (
            <CodarxCard style={{ marginBottom: 32 }}>
              <h2 className={"title"}>مناطق تحت پوشش</h2>
              <MapContainer
                center={LocMarker.length > 0 ? LocMarker : [35.7153, 51.4043]}
                zoom={13}
                ref={mapRef}
                className="geo-map"
              >
                <MapClickHandler />
                <TileLayer
                  attribution='&copy; <a href="https://codarx.com">Codarx</a>'
                  url="https://osm.pspegah.com/styles/basic/512/{z}/{x}/{y}.png"
                />
                {polygon.length > 2 && (
                  <Polygon
                    positions={polygon.map((pl) => [pl.lat, pl.lng])}
                    pathOptions={{
                      color: colorPalette.primary.main,
                      dashArray: "6",
                    }}
                  />
                )}
                {coverages.map((zone, index) => (
                  <div key={`coverage-${index}`}>
                    <Polygon
                      positions={zone.coordinates.map((c) => [c.lng, c.lat])}
                      pathOptions={{
                        color: "#02b73b",
                        dashArray: "6",
                      }}
                    />
                    <Marker
                      position={zone.center}
                      icon={L.divIcon({
                        html: `<div style="background: white; border-radius: 4px; padding: 8px; white-space:nowrap; width: fit-content; font-family: iranyekan; font-size: 10px;">
                      ${zone.name}
                        </div>`,
                        className: "",
                        iconSize: [20, 20],
                        iconAnchor: [14, 8],
                      })}
                    ></Marker>
                  </div>
                ))}
                {polygon.map((point, idx) => (
                  <Marker
                    key={`marker-${idx}-${colorPalette.primary.main}`}
                    position={[point?.lat, point?.lng]}
                    icon={L.divIcon({
                      html: `<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_i_476_7772)"><circle cx="6.5" cy="6.5" r="4.5" fill="${colorPalette.primary.main}" /></g><circle cx="6.5" cy="6.5" r="5.5" stroke="${colorPalette.primary.main}" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"/><defs><filter id="filter0_i_476_7772" x="0" y="0" width="13" height="17" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="shape" result="effect1_innerShadow_476_7772"/></filter></defs></svg>`,
                      className: "",
                      iconSize: [20, 20],
                      iconAnchor: [14, 8],
                    })}
                    draggable={true}
                    eventHandlers={{
                      dragstart: () => {
                        isMarkerDragging.current = true;
                      },
                      dragend: (e) => {
                        updatePoint(idx, e.target.getLatLng());
                        setTimeout(() => {
                          isMarkerDragging.current = false;
                        }, 50);
                      },
                      mouseover: () => {
                        clearTimeout(hoverTimeout.current);
                        setHoveredIndex(idx);
                      },
                      mouseout: () => {
                        hoverTimeout.current = setTimeout(() => {
                          setHoveredIndex(null);
                        }, 200);
                      },
                    }}
                  />
                ))}
                {hoveredIndex !== null && polygon[hoveredIndex] && (
                  <Marker
                    key={`delete-${hoveredIndex}`}
                    position={[
                      polygon[hoveredIndex]?.lng,
                      polygon[hoveredIndex]?.lat,
                    ]}
                    icon={deleteIcon}
                    eventHandlers={{
                      click: () => deletePoint(hoveredIndex),
                      mouseover: () => {
                        clearTimeout(hoverTimeout.current);
                        setHoveredIndex(hoveredIndex);
                      },
                      mouseout: () => {
                        hoverTimeout.current = setTimeout(() => {
                          setHoveredIndex(null);
                        }, 200);
                      },
                    }}
                  />
                )}
              </MapContainer>
            </CodarxCard>
          ) : (
            <Skeleton height={500} />
          )}
          {/* {formik.values.id ? (
            <CodarxCard style={{ marginBottom: 32 }}>
              <h2 className={"title"}>آدرس</h2>
              <p>{formik.values.address}</p>
              <MapComponent
                containerStyle={{
                  borderRadius: 12,
                  height: 350,
                }}
                onDrag={(e) => {
                  setMarkerArray([
                    <MapMarker coordinates={e.getCenter()} anchor="bottom" />,
                  ]);
                }}
                onClick={mapOnClick}
                userLocation={true}
                zoom={[12]}
                center={formik.values.coordinates}
              >
                {markerArray}
              </MapComponent>
            </CodarxCard>
          ) : (
            <Skeleton height={250} />
          )} */}
          {/* <VendorProducts /> */}
          <CodarxCard style={{ marginBottom: 32 }}>
            <h2 className={"title"}>بازه های ارسال</h2>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 12,
              }}
            >
              <CodarxBtn
                ghost={true}
                onClick={() => setDeliveryRangeModal(true)}
                width="160"
                height="40"
              >
                افزودن
              </CodarxBtn>
            </div>
            {weekDays.map((wd) => (
              <div className={styles.delivery_range_row}>
                <h4>{wd.label}</h4>
                <div className="d-flex align-items-center flex-wrap">
                  {deliveryRanges
                    .filter((item) => item.day.toLowerCase() === wd.id)
                    .map((item) => (
                      <Tag
                        style={{ margin: "8px 12px" }}
                        closable={true}
                        onClose={() =>
                          !loading && _deleteDeliveryRange(item.id)
                        }
                      >
                        {`${item.start_time} - ${item.end_time}\nتعداد پیک: ${item.default_capacity}`}
                      </Tag>
                    ))}
                </div>
              </div>
            ))}
          </CodarxCard>
          <CodarxCard
            style={{
              marginBottom: 32,
            }}
          >
            <div
              style={{
                marginBottom: 32,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h2>تعطیلات</h2>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (holidayDate)
                    createHoliday.mutate({
                      body: {
                        vendor: id,
                        date: holidayDate,
                      },
                    });
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  width: "100%",
                  justifyContent: "end",
                }}
              >
                <span style={{ display: "block", width: "max-content" }}>
                  روز تعطیل جدید:{" "}
                </span>
                <div>
                  <CodarxDatePicker
                    locale={fa_IR}
                    placeholder={"تاریخ"}
                    onChange={(e, _) =>
                      setHolidayDate(moment(e).format("YYYY/MM/DD"))
                    }
                  />
                </div>

                <Button type="ghost" htmlType="submit" size="large">
                  ایجاد
                </Button>
              </form>
            </div>
            <ul className={styles.holiday_list}>
              {holidays?.results?.map((item) => (
                <li key={item.id} className={styles.holiday_item}>
                  <span>
                    روز:{" "}
                    {new Intl.DateTimeFormat("fa-IR").format(
                      new Date(item.date),
                    )}
                  </span>
                  <Button
                    type="primary"
                    danger
                    onClick={() => deleteHoliday.mutate({ id: item.id })}
                  >
                    حذف
                  </Button>
                </li>
              ))}
            </ul>
          </CodarxCard>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 8 }}>
          {formik.values.id ? (
            <CodarxCard style={{ marginBottom: 32 }}>
              <h2 className={"title"}>بخش های فروشگاه</h2>
              <Checkbox.Group
                value={formik.values.supported_segment}
                onChange={(val) => {
                  formik.setFieldValue("supported_segment", val);
                }}
                options={segments.map((item) => {
                  return { label: item.name, value: item.id };
                })}
              />
            </CodarxCard>
          ) : (
            <Skeleton style={{ marginBottom: 32 }} height={150} />
          )}
          {formik.values.id ? (
            <CodarxCard style={{ marginBottom: 32 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h2 className={"title"}>آدرس</h2>
                <CodarxBtn
                  type="primary"
                  ghost
                  icon={
                    isEditingMap ? (
                      <i
                        className="iconly-Check"
                        style={{ margin: "0 4px" }}
                      ></i>
                    ) : (
                      <i
                        className="iconly-Edit"
                        style={{ margin: "0 4px" }}
                      ></i>
                    )
                  }
                  width={120}
                  onClick={() => setIsEditingMap(!isEditingMap)}
                >
                  {isEditingMap ? "ثبت" : "ویرایش"}
                </CodarxBtn>
              </div>
              <p>{formik.values.address}</p>
              {/* <MapComponent
                containerStyle={{
                  borderRadius: 12,
                  height: 350,
                }}
                onDrag={(e) => {
                  setMarkerArray([
                    <MapMarker coordinates={e.getCenter()} anchor="bottom" />,
                  ]);
                }}
                onClick={mapOnClick}
                userLocation={true}
                zoom={[12]}
                center={formik.values.coordinates}
              >
                {markerArray}
              </MapComponent> */}
              <MapContainer
                center={LocMarker.length > 0 ? LocMarker : [35.7153, 51.4043]}
                zoom={13}
                ref={mapLocRef}
                className="loc-map"
                style={{
                  height: 350,
                  borderRadius: 12,
                }}
              >
                {LocMarker.length > 0 && (
                  <Marker
                    position={LocMarker}
                    icon={L.divIcon({
                      html: `<svg width="32" height="38" viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_448_2246)">
<path d="M20.2 24.2C20.2 24.2597 20.1759 24.3731 20.0178 24.5393C19.8559 24.7094 19.5862 24.8967 19.1956 25.0703C18.4163 25.4166 17.2871 25.65 16 25.65C14.713 25.65 13.5838 25.4166 12.8045 25.0703C12.4139 24.8967 12.1442 24.7094 11.9823 24.5393C11.8242 24.3731 11.8 24.2597 11.8 24.2C11.8 24.1403 11.8242 24.0269 11.9823 23.8607C12.1442 23.6906 12.4139 23.5033 12.8045 23.3297C13.5838 22.9834 14.713 22.75 16 22.75C17.2871 22.75 18.4163 22.9834 19.1956 23.3297C19.5862 23.5033 19.8559 23.6906 20.0178 23.8607C20.1759 24.0269 20.2 24.1403 20.2 24.2Z" stroke="#2065B1" stroke-width="1.5" shape-rendering="crispEdges"/>
</g>
<path d="M23.9018 7.74584C22.9393 3.51084 19.2451 1.60417 16.0001 1.60417C16.0001 1.60417 16.0001 1.60417 15.9909 1.60417C12.7551 1.60417 9.05175 3.50167 8.08925 7.73667C7.01675 12.4667 9.91342 16.4725 12.5351 18.9933C13.5068 19.9283 14.7534 20.3958 16.0001 20.3958C17.2468 20.3958 18.4934 19.9283 19.4559 18.9933C22.0776 16.4725 24.9743 12.4758 23.9018 7.74584ZM16.0001 12.3383C14.4051 12.3383 13.1126 11.0458 13.1126 9.45084C13.1126 7.85584 14.4051 6.56334 16.0001 6.56334C17.5951 6.56334 18.8876 7.85584 18.8876 9.45084C18.8876 11.0458 17.5951 12.3383 16.0001 12.3383Z" fill="#2065B1"/>
<defs>
<filter id="filter0_d_448_2246" x="0.0500488" y="11" width="31.8999" height="26.4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_448_2246"/>
<feOffset/>
<feGaussianBlur stdDeviation="5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_448_2246"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_448_2246" result="shape"/>
</filter>
</defs>
</svg>
`,
                      className: "",
                      iconSize: [40, 40],
                      iconAnchor: [14, 8],
                    })}
                  ></Marker>
                )}
                <TileLayer
                  attribution='&copy; <a href="https://codarx.com">Codarx</a>'
                  url="https://osm.pspegah.com/styles/basic/512/{z}/{x}/{y}.png"
                />
                <LocMapClickHandler />
              </MapContainer>
              {formik.errors.coordinates && (
                <div style={{ color: colorPalette.text.op_3, fontSize: 10 }}>
                  <img
                    style={{ height: 13, marginLeft: 3 }}
                    src={DangerVector}
                  />
                  {formik.errors.coordinates}
                </div>
              )}
            </CodarxCard>
          ) : (
            <Skeleton height={250} />
          )}
          {formik.values.id ? (
            <CodarxCard style={{ marginBottom: 32 }}>
              <h2 className={"title"}>تنظیمات ارسال</h2>
              <div style={{ marginBottom: 16 }}>
                <CodarxInput
                  placeholder={"هزینه پیک"}
                  message={
                    formik.errors.shipping_cost && {
                      type: "error",
                      rightComponent: formik.errors.shipping_cost,
                    }
                  }
                  onChange={(e) => {
                    formik.setFieldValue(
                      "shipping_cost",
                      _parseInputPrice(e.target.value),
                    );
                  }}
                  value={
                    formik.values.shipping_cost
                      ? parseInt(formik.values.shipping_cost)?.toLocaleString()
                      : "0"
                  }
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <CodarxInput
                  placeholder={"حداقل مبلغ خرید"}
                  message={
                    formik.errors.minimum_purchase && {
                      type: "error",
                      rightComponent: formik.errors.minimum_purchase,
                    }
                  }
                  onChange={(e) => {
                    formik.setFieldValue(
                      "minimum_purchase",
                      _parseInputPrice(e.target.value),
                    );
                  }}
                  value={
                    formik.values.minimum_purchase
                      ? parseInt(
                          formik.values.minimum_purchase,
                        )?.toLocaleString()
                      : "0"
                  }
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <CodarxInput
                  type={"number"}
                  placeholder={"زمان ارسال"}
                  message={
                    formik.errors.shipping_time && {
                      type: "error",
                      rightComponent: formik.errors.shipping_time,
                    }
                  }
                  onChange={(e) => {
                    formik.setFieldValue(
                      "shipping_time",
                      _parseInputPrice(e.target.value),
                    );
                  }}
                  value={
                    formik.values.shipping_time
                      ? parseInt(formik.values.shipping_time)?.toLocaleString()
                      : "0"
                  }
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <CodarxInput
                  type={"number"}
                  placeholder={"زمان ارسال"}
                  message={
                    formik.errors.time_to_delivery && {
                      type: "error",
                      rightComponent: formik.errors.time_to_delivery,
                    }
                  }
                  onChange={(e) =>
                    formik.setFieldValue("time_to_delivery", e.target.value)
                  }
                  value={formik.values.time_to_delivery}
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <CodarxInput
                  type={"number"}
                  placeholder={"ارسال رایگان"}
                  message={
                    formik.errors.free_delivery && {
                      type: "error",
                      rightComponent: formik.errors.free_delivery,
                    }
                  }
                  onChange={(e) =>
                    formik.setFieldValue("free_delivery", e.target.value)
                  }
                  value={formik.values.free_delivery}
                />
              </div>
            </CodarxCard>
          ) : (
            <Skeleton height={250} />
          )}
          {formik.values.id ? (
            <CodarxCard style={{ marginBottom: 32 }}>
              <h2 className={"title"}>راکب</h2>
              <CustomDorpDown
                showSearch
                type="conatained"
                placeholder="راکب فروشگاه را انتخاب کنید"
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={(val) => {
                  setUserSearchDebounce(val);
                }}
                onSelect={(_, val) => {
                  formik.setFieldValue("rider", [
                    ...formik.values.rider,
                    { full_name: val?.children, id: val?.value },
                  ]);
                }}
                colorPalette={colorPalette}
                notFoundContent={null}
                style={{
                  width: "100%",
                  borderRadius: 8,
                }}
                options={(users?.results || []).map((d) => ({
                  value: d.id,
                  label: d.full_name,
                }))}
              />
              {formik.values.rider.map((item) => (
                <Tag
                  style={{ margin: "8px 12px" }}
                  closable={true}
                  onClose={() =>
                    formik.setFieldValue(
                      "rider",
                      formik.values.rider.filter((_rd) => _rd.id != item.id),
                    )
                  }
                >
                  {item.full_name}
                </Tag>
              ))}
            </CodarxCard>
          ) : (
            <Skeleton height={250} />
          )}
          {formik.values.id ? (
            <CodarxCard style={{ marginBottom: 32 }}>
              <h2 className={"title"}>شناسه سبز</h2>
              <CodarxInput
                type={"text"}
                placeholder={"شناسه سبز"}
                message={
                  formik.errors.sabz_id && {
                    type: "error",
                    rightComponent: formik.errors.sabz_id,
                  }
                }
                onChange={(e) =>
                  formik.setFieldValue("sabz_id", e.target.value)
                }
                value={formik.values.sabz_id}
              />
            </CodarxCard>
          ) : (
            <Skeleton height={250} />
          )}
        </Col>
      </Row>
      <CodarxActionRow
        okComp={
          IsUserPermitted("vendor", "change") && (
            <CodarxBtn
              block={true}
              onClick={() => formik.submitForm()}
              height={40}
              loading={loading}
            >
              ذخیره
            </CodarxBtn>
          )
        }
        deleteComp={
          IsUserPermitted("vendor", "delete") && (
            <Popconfirm
              placement="top"
              title={"آیا از حذف فروشگاه اطمینان دارید؟"}
              description={"عملیات غیر قابل بازگشت است"}
              onConfirm={() =>
                DeleteVendor(id)
                  .then((res) => {
                    notification.success({
                      message: "درخواست شما با موفقیت انجام شد.",
                    });
                    navigate("/vendors");
                  })
                  .catch((error) => {})
              }
              okText="بله"
              cancelText="لغو"
            >
              <CodarxBtn type="danger" height={40} ghost={true} block={true}>
                پاک کردن
              </CodarxBtn>
            </Popconfirm>
          )
        }
        cancelComp={
          <CodarxBtn
            block={true}
            onClick={() => navigate(-1)}
            height={40}
            ghost={true}
          >
            بازگشت
          </CodarxBtn>
        }
      />
    </div>
  );
}
